module.exports = __webpack_public_path__ + "img/active-29.7c3fb361.svg";